<!-- 信息公开 -->
<template>
  <div :class="{ pageView: [6, 7].includes(current) || baogao.id }" ref="scrollableDiv">
    <PCNavbar />
    <CarouselHome type="information" />
    <div class="main-wrap" style="height: auto;">
      <div class="block-wrap" style="height: auto;">
        <div class="tab">
          <div class="tab-item" :class="{ current: current == item.id }" v-for="(item, index) in fenlei" :key="index" @click="toggle(item.id)">
            {{ item.title }}
          </div>
        </div>
        <div class="article" v-show="current == 5" :style="{ padding: platform == 'web' ? 0 : 'sdsadsa' }">
          <div class="list" v-if="newsList.length" :style="platform == 'web' ? 'gap: 40px' : ''">
            <div class="list-card" v-for="(item, index) in newsList" :key="index">
              <div class="title" style="font-size: 15px;text-align: center;">{{ item.title }}</div>
              <div class="info">
                <div class="time">{{ item.time }}</div>
                <el-link class="lookMore" :underline="false" @click="handleLookZizhi(item)">查看</el-link>
              </div>
              <el-image :src="item.cover" class="img1" />
            </div>
          </div>
          <div class="look" v-show="lookZizhi.id">
            <el-image style="width: 100%;" :src="lookZizhi.cover" />
          </div>
        </div>
        <div class="article" v-show="current > 10" @scroll="handleScroll">
          <div class="list">
            <div class="list-item" v-for="(item, index) in newsList" :key="index">
              <div class="picture-box">
                <img :src="item.cover" class="pictrue" />
                <div class="mask">
                  <a class="btn" @click="lookDetails(item)">查看详情</a>
                  <a class="btn" @click="download(item)">下载</a>
                </div>
              </div>
              <h3 class="title">{{ item.title }}</h3>
            </div>
          </div>
        </div>
        <div class="box relative" v-show="current == 6">
          <div class="list" v-if="newsList.length">
            <div class="list-box detailBlock" v-for="(item, index) in newsList" :key="index" @click="lookDetails(item)">
              <el-image :src="item.image" class="img" />
              <div class="info flex-column">
                <div>
                  <div class="title">{{ item.title }}</div>
                  <div class="time">{{ item.show_time }}</div>
                </div>
                <el-link :underline="false" class="lookMore">查看详情</el-link>
              </div>
            </div>
          </div>
        </div>
        <div class="box" v-show="current == 7">
          <div class="head1">
            <h3 class="h3">{{ detail.title }}</h3>
            <div class="time">发布时间：{{ detail.show_time?.slice(0, 10) }}</div>
          </div>
          <div class="content" v-html="detail.content"></div>
        </div>
        <div class="pagination" v-show="[1, 2, 3, 4].includes(current)">
          <el-pagination ref="pagination" layout="slot" :total="total" :current-page="page" hide-on-single-page>
            <div>
              <el-button type="text" class="custom-btn" :disabled="page <= 1" @click="handlePrevChange">
                <i class="el-icon-arrow-left"></i>
                上一页
              </el-button>
              <el-button type="text" class="custom-btn" :disabled="page >= lastPage" @click="handleNextChange">
                下一页
                <i class="el-icon-arrow-right"></i>
              </el-button>
            </div>
          </el-pagination>
        </div>
      </div>
    </div>
    <Footer />
    <el-dialog :visible.sync="dialogVisible" width="324px" center append-to-body top="30vh" :show-close="false" :custom-class="'custom-dialog'">
      <div class="dialog">
        <div class="dialog-popup">
          <img src="@/assets/images/success.png" />
          <div class="dialog-title">下载成功</div>
          <div class="dialog-content">报告下载成功，请前往本地查看</div>
        </div>
        <i class="el-icon-circle-close" @click="dialogVisible = false" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { mapState } from "vuex";
import { baseURL } from "@/utils/http";
import { formatDate } from "@/utils/tools";
import PCNavbar from "@/components/navbar/index";
import CarouselHome from "@/components/carousel_home/index";
import Footer from "@/components/footer/index";

export default {
  name: "Information",
  components: { PCNavbar, CarouselHome, Footer },
  data() {
    return {
      baseURL,
      current: 1,
      fenlei: [],
      newsList: [],
      detail: {},
      page: 1,
      total: 0,
      scrollTop: 0,
      lastPage: 1,
      lookZizhi: {},
      baogao: {},
      piwen: {},
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState(["platform"]),
  },
  async created() {
    await this.getFenlei();
    this.page = 1
    this.$watch(
      "$route",
      (to) => {
        const index = to.params.id || 1;
        this.toggle(Number(index));
      },
      { immediate: true }
    );
  },
  mounted() {
    this.newsList = []
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      console.log(12312312)
      if (window.scrollY > this.scrollTop) {
        this.page++
        this.getList2()
        this.scrollTop = window.scrollY
      }
    },
    toggle(index) {
      this.current = index;
      this.newsList = []
      this.lookZizhi = {};
      this.baogao = {};
      this.piwen = {};
      if (index == 5) {
        this.getList();
      } else if (index > 10) {
        this.page = 1;
        this.getList2();
      } else if (index == 6) {
        this.page = 1;
        this.getList3();
      } else if (index == 7) {
        this.page = 1;
        this.getList4();
      }
      this.$store.dispatch("setMenuActive", "/information?type=" + index);
      // 更新路由参数
      // this.$router.replace({
      //   path: "/information",
      //   query: { ...this.$route.query, type: index },
      // });
    },

    async getFenlei() {
      const res = await CifuAPI.getReportType();
      if (res.code == 1) {
        this.fenlei = res.data;
        this.fenlei.unshift({ id: 5, title: "资质证书" });
        this.fenlei.push({ id: 6, title: "免税批文" });
      }
    },
    async getList() {
      const res = await CifuAPI.getCertificateList();
      if (res.code == 1) {
        res.data.forEach((item) => {
          item.time = formatDate(item.updatetime * 1000, "YYYY年MM月DD日");
        });
        this.newsList = res.data;
      }
    },
    async getList2() {
      const id = this.current;
      const res = await CifuAPI.getReportList({ type_id: id, limit: 10, page: this.page });
      if (res.code == 1) {
        this.newsList = this.newsList.concat(res.data);
      }
    },
    async getList3() {
      const res = await CifuAPI.getArticleList({ model_type: "mspw" });
      if (res.code == 1) {
        this.newsList = res.data.data;
      }
    },
    async getList4() {
      const res = await CifuAPI.getArticleDetail({ unicode: "xinxigongkai" });
      if (res.code == 1) {
        this.detail = res.data;
      }
    },
    handleToNewsDetails(id) {
      this.$router.push(`/newsDetail?type=0&id=${id}`);
    },
    handlePrevChange() {
      const index = this.current;
      this.page--;
      this.toggle(index);
    },
    handleNextChange() {
      const index = this.current;
      this.page++;
      this.toggle(index);
    },
    lookDetails(item) {
      let windowUrl = ''
      if (item.content_file) {
        windowUrl = this.$router.resolve({
          path: '/pdfLook',
          query: { fileUrl: item.content_file }
        })
        window.open(windowUrl.href, '_blank')
      } else {
        windowUrl = this.$router.resolve({
          path: '/pdfLook',
          query: { fileUrl: item.file_content }
        })
        window.open(windowUrl.href, '_blank')
      }
    },
    handleLookZizhi(item) {
      window.sessionStorage.setItem("detail", JSON.stringify(item));
      this.$router.push(`/informationDetail?id=${item.id}&pageType=zhengshu`);
    },
    lookPiwen(item) {
      window.sessionStorage.setItem("detail", JSON.stringify(item));
      this.$router.push(`/informationDetail?id=${item.id}&type=${this.current}`);
    },
    //获取文件名称
    getFileNameFromURL(url) {
      const urlParts = url.split("/");
      return decodeURIComponent(urlParts[urlParts.length - 1]);
    },
    download(item) {
      try {
        const fileUrl = item.content_file; // 获取文件地址
        const a = document.createElement("a");
        const fileName = this.getFileNameFromURL(item.content_file);
        a.target = "_blank";
        a.href = fileUrl;
        a.download = fileName; // 可留空由浏览器决定文件名，或手动设置
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
        }, 300);
        this.dialogVisible = true;
      } catch (error) {
        console.error("下载异常:", error);
        this.$message.error("下载过程中发生错误");
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.img1{
  width: 100%;
}
.article {
  .h3 {
    font-size: 28px;
    color: #663301;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      font-size: 16px;
    }
  }
}
.relative {
  position: relative;
  z-index: 1;
}
.list {
  gap: 30px;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    gap: 10px;
  }
  &-item {
    @media screen and (max-width: 1600px) and (min-width: 1200px) {
      width: calc((100% - 30px * 3) / 4);
    }
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      flex: 1 0 calc(50% - 5px);
      // max-width: calc(50% - 5px) !important;
    }
    .picture-box {
      @media screen and (max-width: 1600px) and (min-width: 1200px) {
        // height: 376px;
      }
      
      // 处理浏览器放大后的情况
      @media screen and (min-width: 1201px) {
        min-width: auto; // 1200px以上恢复完全响应式
      }
    }
    .mask {
      .btn {
        padding: 0;
      }
    }
  }
  .flex-column {
    .lookMore {
      display: block;
    }
  }
}
.look {
  position: absolute;
  width: 100%;
  background: #d9d9d9;
  z-index: 2;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    padding: 20px;
  }
}
.box {
  padding: 0 50px;
  background: white;
  margin-bottom: 50px;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    padding: 0;
  }
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 64px 0 26px;
    border-bottom: 1px solid #e0e0e0;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding: 20px;
    }
    .h3 {
      font-size: 28px;
      color: #333;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        font-size: 16px;
      }
    }
    .time {
      font-size: 18px;
      color: #333;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        font-size: 12px;
      }
    }
  }
  .head1{
    padding: 64px 0 26px;
    border-bottom: 1px solid #e0e0e0;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding: 20px;
    }
    .h3 {
      font-size: 28px;
      color: #333;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        font-size: 16px;
      }
    }
    .time {
      padding-top: 10px;
      font-size: 18px;
      color: #333;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        font-size: 12px;
      }
    }
  }
  .content {
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding: 20px;
    }
  }
  .list-box {
    width: 100%;
    padding: 40px 0;
    border-bottom: 1px solid #e0e0e0;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding: 20px;
    }
    &:last-child {
      border-bottom: none;
    }
  }
  a {
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      width: 100%;
      word-wrap: break-word;
    }
  }
}
.pictrue {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}
.detailBlock:hover{
  cursor: pointer;
}
</style>
